<div class="wrapper-ng-content">
    <ng-content></ng-content>
  <div style="display: block; height: 22px; width: 100%"></div>
</div>
